module.exports = __webpack_public_path__ + "img/logo-th.7278daee.png";